<template>
    <section class="article">
        <div class="container about-us">
            <div class="row">
                <div class="col-12 head">
                    <h2 class="title">{{ $t('about_us.title') }}</h2>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                            <h2><span id="professionalism">{{ $t('about_us.paragraph_1_title') }}</span></h2>
                            <div class="carousel-floating float-right p-0 pl-md-3 pb-md-2">
                                <div id="carousel01Indicators" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="../assets/img/genomed_sa_01.jpg" class="d-block w-100"
                                                alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../assets/img/genomed_sa_02.jpg" class="d-block w-100"
                                                alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../assets/img/carousel_01_img_03.jpg" class="d-block w-100"
                                                alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../assets/img/carousel_01_img_04.jpg" class="d-block w-100"
                                                alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../assets/img/carousel_01_img_05.jpg" class="d-block w-100"
                                                alt="...">
                                        </div>
                                    </div>
                                    <ol class="carousel-indicators">
                                        <li data-target="#carousel01Indicators" data-slide-to="0" class="active"></li>
                                        <li data-target="#carousel01Indicators" data-slide-to="1"></li>
                                        <li data-target="#carousel01Indicators" data-slide-to="2"></li>
                                        <li data-target="#carousel01Indicators" data-slide-to="3"></li>
                                        <li data-target="#carousel01Indicators" data-slide-to="4"></li>
                                    </ol>
                                    <a class="carousel-control-prev" href="#carousel01Indicators" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carousel01Indicators" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                            <div class="about_us_content" v-html="$t('about_us.paragraph_1_content')"></div>
                        </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                    <h2><span id="medical_knowledge">{{ $t('about_us.paragraph_2_title') }}</span></h2>
                    <div class="carousel-floating float-left p-0 pr-md-3 pb-md-3">
                        <div id="carousel02Indicators" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../assets/img/zespol_01.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_02.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_03.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_04.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_05.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_06.jpg" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/zespol_07.jpg" class="d-block w-100" alt="...">
                                </div>
                            </div>
                            <ol class="carousel-indicators">
                                <li data-target="#carousel02Indicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="1"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="2"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="3"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="4"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="5"></li>
                                <li data-target="#carousel02Indicators" data-slide-to="6"></li>
                            </ol>
                            <a class="carousel-control-prev" href="#carousel02Indicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carousel02Indicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_2_content')"></div>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                    <h2><span id="polish_reference_database">{{ $t('about_us.paragraph_3_title') }}</span></h2>
                    <div class="carousel-floating float-right p-0 pl-md-3 pb-md-3">
                        <div id="carousel03Indicators" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../assets/img/carousel_03_img_03.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_03_img_01.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_03_img_02.png" class="d-block w-100" alt="...">
                                </div>
                            </div>
                            <ol class="carousel-indicators">
                                <li data-target="#carousel03Indicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carousel03Indicators" data-slide-to="1"></li>
                                <li data-target="#carousel03Indicators" data-slide-to="2"></li>
                            </ol>
                            <a class="carousel-control-prev" href="#carousel03Indicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carousel03Indicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_3_content')"></div>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                    <h2><span id="our_tools">{{ $t('about_us.paragraph_4_title') }}</span></h2>
                    <div class="carousel-floating float-left p-0 pr-md-3 pb-md-3">
                        <div id="carousel04Indicators" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="../assets/img/carousel_04_img_01.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_04_img_02.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_04_img_03.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_04_img_04.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_04_img_05.png" class="d-block w-100" alt="...">
                                </div>
                                <div class="carousel-item">
                                    <img src="../assets/img/carousel_04_img_06.png" class="d-block w-100" alt="...">
                                </div>
                            </div>
                            <ol class="carousel-indicators">
                                <li data-target="#carousel04Indicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carousel04Indicators" data-slide-to="1"></li>
                                <li data-target="#carousel04Indicators" data-slide-to="2"></li>
                                <li data-target="#carousel04Indicators" data-slide-to="3"></li>
                                <li data-target="#carousel04Indicators" data-slide-to="4"></li>
                                <li data-target="#carousel04Indicators" data-slide-to="5"></li>
                            </ol>
                            <a class="carousel-control-prev" href="#carousel04Indicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carousel04Indicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_4_content')"></div>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                    <h2><span id="">{{ $t('about_us.paragraph_5_title') }}</span></h2>
                    <div class="carousel-floating float-right p-0 pl-md-3 pb-md-3">
                            <div id="carousel05Indicators" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="../assets/img/carousel_05_img_01.png" class="d-block w-100" alt="...">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="../assets/img/carousel_05_img_02.png" class="d-block w-100" alt="...">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="../assets/img/carousel_05_img_03.png" class="d-block w-100" alt="...">
                                    </div>
                                    <div class="carousel-item">
                                        <img src="../assets/img/carousel_05_img_04.png" class="d-block w-100" alt="...">
                                    </div>
                                </div>
                                <ol class="carousel-indicators">
                                    <li data-target="#carousel05Indicators" data-slide-to="0" class="active"></li>
                                    <li data-target="#carousel05Indicators" data-slide-to="1"></li>
                                    <li data-target="#carousel05Indicators" data-slide-to="2"></li>
                                    <li data-target="#carousel05Indicators" data-slide-to="3"></li>
                                </ol>
                                <a class="carousel-control-prev" href="#carousel05Indicators" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carousel05Indicators" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                    </div>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_5_content')"></div>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12 pb-5">
                    <h2><span id="confidence"></span>{{ $t('about_us.paragraph_6_title') }}</h2>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_6_content')"></div>
                </div>
            </div>
            <div class="row text-justify about_us paragraph">
                <div class="col-12">
                    <h2>{{ $t('about_us.paragraph_7_title') }}</h2>
                    <div class="about_us_content" v-html="$t('about_us.paragraph_7_content')"></div>
                    <div class="row certifiates-grid pt-4 pb-4">
                        <div class="col-6 col-md-3 certificate-col text-center border-right">
                            <div class="row h-100">
                                <div class="col-12 align-self-center">
                                    <img src="../assets/img/cert_1.jpg" class="img-fluid" alt="..."><br>
                                </div>

                                <div class="col-12 align-self-end pt-3">
                                    2020
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 certificate-col text-center border-right">
                            <div class="row h-100">
                                <div class="col-12 align-self-center">
                                    <img src="../assets/img/cert_2.jpg" class="img-fluid" alt="..."><br>
                                </div>

                                <div class="col-12 align-self-end pt-3">
                                    2021
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 certificate-col text-center border-right">
                            <div class="row h-100">
                                <div class="col-12 align-self-center">
                                    <img src="../assets/img/cert_3.png" class="img-fluid" alt="..."><br>
                                </div>
                                <div class="col-12 align-self-end pt-3">
                                    2020
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-3 certificate-col text-center">
                            <div class="row h-100">
                                <div class="col-12 align-self-center">
                                    <img src="../assets/img/cert_4.jpg" class="img-fluid" alt="..."><br>
                                </div>
                                <div class="col-12 align-self-end pt-3">
                                    2021
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "AboutUs",
        mounted:function(){
        this.scrolltohash()
    },
    methods:{
        scrolltohash:function(){
            const hash = document.getElementById(this.$route.hash.substring(1));
            if (hash != null) {
                const y = hash.getBoundingClientRect().top + window.pageYOffset + -10;
                window.scrollTo({top: y, behavior: 'smooth', block: 'start'});
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/AboutUs.vue